<template>
  <div>
    <canvas ref="carGraph" width="200" height="200"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: 'RadarChartComponent',

  mounted () {
    this.loadGraph(this.$refs['carGraph'])
  },

  methods: {

    loadGraph (carGraph) {
      return new Chart(carGraph, {
        type: 'radar',
        data: {
          labels: ['Eating', 'Dinner', 'Bup'],
          datasets: [{
            label: 'Interes segun provincias',
            showLabel: false,
            backgroundColor: 'rgba(60,141,188,0.9)',
            borderColor: 'rgba(60,141,188,0.8)',
            pointBackgroundColor: 'rgba(60,141,188,0.8)',
            data: [
              3,
              0,
              2
            ]
          }]
        },
        options: {
          legend: {
            position: 'top'
          },
          title: {
            display: true,
            text: 'Chart.js Radar Chart'
          },
          scale: {
            ticks: {
              beginAtZero: true
            }
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/custom/RadarChartComponent.vue